import React, { useState, useEffect } from 'react';
import { MdLogout, MdAccountCircle, MdBusiness, MdArrowBack, MdMenu } from 'react-icons/md';
import NotificationBell from '../../components/NotificationBell';
import { useNotifications } from '../../hooks/useNotifications';

const Header = ({ user, handleLogout, onBackToSuperAdmin, isSidebarOpen, setIsSidebarOpen, onOpenChat, onOpenSupport }) => {
  const [isMobile, setIsMobile] = useState(false);
  const {
    totalCount,
    messageCount,
    supportTicketCount,
    loading,
    refreshCounts
  } = useNotifications(user);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px 0',
      borderBottom: '2px solid #e0e0e0',
      marginBottom: 20,
      backgroundColor: '#fff',
      borderRadius: 8,
      paddingLeft: 20,
      paddingRight: 20,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      {/* Left side - Hamburger and MMDA Info */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
        {isMobile && (
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            style={{
              background: 'none',
              border: 'none',
              color: '#1976d2',
              cursor: 'pointer',
              padding: '8px',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <MdMenu size={24} />
          </button>
        )}
        <MdBusiness size={32} style={{ color: '#1976d2' }} />
        <div>
          <h1 style={{
            margin: 0,
            fontSize: isMobile ? 18 : 24,
            fontWeight: 'bold',
            color: '#1976d2'
          }}>
            {isMobile ? 'MMDA Dashboard' : 'MMDA Revenue Dashboard'}
          </h1>
          <p style={{
            margin: 0,
            fontSize: 14,
            color: '#666',
            fontWeight: 'normal'
          }}>
            {user.mmda_name || 'Regional Administration'}
          </p>
        </div>
      </div>

      {/* Right side - User Info and Logout */}
      <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 10 : 20 }}>
        {/* User Info - Hide on mobile */}
        {!isMobile && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '8px 15px',
            backgroundColor: '#f5f5f5',
            borderRadius: 20,
            border: '1px solid #e0e0e0'
          }}>
            <MdAccountCircle size={24} style={{ color: '#1976d2' }} />
            <div style={{ textAlign: 'right' }}>
              <div style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#333',
                margin: 0
              }}>
                {user.full_name}
              </div>
              <div style={{
                fontSize: 12,
                color: '#666',
                margin: 0
              }}>
                {user.role_name?.replace(/_/g, ' ') || 'MMDA Admin'}
              </div>
            </div>
          </div>
        )}

        {/* Back to Super Admin Button (only show if this is a super admin session and not mobile) */}
        {!isMobile && user.is_super_admin_session && onBackToSuperAdmin && (
          <button
            onClick={onBackToSuperAdmin}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 15px',
              backgroundColor: '#ff9800',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 'bold',
              transition: 'background-color 0.2s ease',
              boxShadow: '0 2px 4px rgba(255, 152, 0, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f57c00';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#ff9800';
            }}
          >
            <MdArrowBack size={18} />
            Back to Super Admin
          </button>
        )}

        {/* Notification Bell */}
        <NotificationBell
          notificationCount={totalCount}
          messageCount={messageCount}
          supportTicketCount={supportTicketCount}
          onClick={refreshCounts}
          onOpenChat={onOpenChat}
          onOpenSupport={onOpenSupport}
          onRefresh={refreshCounts}
          loading={loading}
          size={isMobile ? 20 : 24}
          style={{
            marginRight: isMobile ? 5 : 10
          }}
        />

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: isMobile ? '8px 12px' : '10px 15px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: isMobile ? 12 : 14,
            fontWeight: 'bold',
            transition: 'background-color 0.2s ease',
            boxShadow: '0 2px 4px rgba(244, 67, 54, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#d32f2f';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#f44336';
          }}
        >
          <MdLogout size={18} />
          {!isMobile && 'Logout'}
        </button>
      </div>
    </div>
  );
};

export default Header;
